/**
 * Created by lzy 2020-12-30
 * 短视频后台管理功能，目前只用于抖音和快手
 */
'use strict';
angular.module('productManageMentShortVideoModule', []).controller('productManageMentShortVideoCtrl', ['$scope', '$timeout', 'trsHttpService', 'modalDialog', 'permissionService', 'editcenterRightsService', 'productManageMentService', 'productManagementWeixinService',
    function($scope, $timeout, trsHttpService, modalDialog, permissionService, editcenterRightsService, productManageMentService, productManagementWeixinService) {
        initStatus();
        initData();
        window.addEventListener('storage', function(e) {
            event(e);
        });
        var event = function(e) {
            $timeout(function() {
                if (e.key === 'weibo.refresh') {
                    requestData();
                }
            }, 1);
        };
        $scope.$on('$destroy', function() {
            event = function() {};
        });

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {

            /**
             * [page description:分页信息]
             */
            $scope.page = {
                'CURRPAGE': 1,
                'PAGESIZE': 100,
                'ITEMCOUNT': 0,
                'PAGECOUNT': 1,
            };
            $scope.status = {
                copyCurrPage: 1,
                isAdministrator: false,
                rights: {},
            };
            $scope.data = {
                items: [],
                selectedArray: [],
            };
            $scope.searchWord = '';

            /**
             * 判断是否是管理员
             */
            permissionService.isTenantAdministrator().then(function(data) {
                $scope.status.isAdministrator = data;
            });
        }

        /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
        function initData() {
            requestData();

            /**
             * 判断是否是管理员
             */
            permissionService.isTenantAdministrator().then(function(data) {
                $scope.status.isAdministrator = data;
            });
        }

        /**
         * [requestData description] 请求数据
         * @return {[type]} [description]
         */
        function requestData() {
            $scope.data.selectedArray = [];
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.searchParams, 'get').then(function(data) {
                $timeout(function() {
                    !!data.DATA ? $scope.data.items = data.DATA : $scope.data.items = data;
                    !!data.PAGER ? $scope.page = data.PAGER : $scope.page.ITEMCOUNT = '0';
                });
            });
        }

        /**
             * [initBtnRights description]初始化权限
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
        function initBtnRights(item) {
            $scope.rightsParams[$scope.mediaAccountKey] = item[$scope.mediaAccountKey] || item[$scope.accountKey];
            editcenterRightsService.initListBtn($scope.rightsParams).then(function(data) {
                item.rights = data;
            });
        }

        /**
             * [searchRequestData description]搜索
             *
             * @param   {[type]}  ev  [ev description]
             *
             * @return  {[type]}      [return description]
             */
        $scope.searchRequestData = function(ev) {
            const searchkeywords = {
                kuaishou: 'AccountName',
                trill: 'douYinAccountName'
            };
            if ((angular.isDefined(ev) && ev.keyCode === 13) || angular.isUndefined(ev)) {
                $scope.searchParams[searchkeywords[$scope.mediaType]] = $scope.searchWord;
                requestData();
            }
        };

        /**
             * [create description] 新增抖音账号
             * @return {[type]} [description]
             */
        $scope.create = function() {
            var params = $scope.newAccountParams;
            $scope.loadingPromise = trsHttpService.httpServer('/wcm/rbcenter.do', params, 'post', true).then(function(data) {
                window.open(JSON.parse(data));
                $timeout(function() {
                    productManagementWeixinService.newWechatBindModel(JSON.parse(data)).then(() => {
                        requestData();
                    });
                }, 500);
            });
        };

        /**
         * [revise description] 重置排序方法
         *
         * @return  {[type]}  [return description]
         */
        $scope.resetAccountOrder = function() {
            if ($scope.data.selectedArray.length > 1) {
                modalDialog.alertType('请选择一个' + $scope.mediaName + '号', '', 'warning', false);
                return;
            } else {
                if ($scope.data.selectedArray[0].rights[$scope.rightsKey + '.edit']) {
                    productManageMentService.resetAccountOrder($scope.mediaType, $scope.data.selectedArray[0], $scope.data.items, function(result) {
                        if (result === 'success') {
                            modalDialog.alertType('排序成功', '', 'success', false);
                            requestData();
                        } else {
                            modalDialog.alertType('排序失败', result.DETAIL, 'error', 'confirm');
                        }
                    });
                } else {
                    modalDialog.alertType('该' + $scope.mediaName + '号账号没有编辑权限', '', 'error', false);
                }
            }
        };

        $scope.reauthorization = function(item) {
            var params = $scope.reAuthorizeParams;
            params[$scope.mediaAccountKey] = item[$scope.accountKey] || item[$scope.mediaAccountKey];
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                if (data.indexOf('https') === -1) {
                    modalDialog.alertType('重新授权成功', '', 'success', false);
                } else {
                    window.open(data.replace(/\"/g, ''));
                }
            });
        };

        /**
         * [deleteAccount description]删除账号
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.deleteAccount = function(item) {
            if (angular.isUndefined(item)) {
                trillDeleteBatch();
            } else {
                modalDialog.alertType('提示信息', '您确定要删除此' + $scope.mediaName + '账号', 'ask', true, function() {
                    deleteTrillAccountMethod(item[$scope.mediaAccountKey] || item[$scope.accountKey]);
                });
            }
        };

        /**
             * [trillDeleteBatch description] 抖音账号批量删除
             * @return {[type]} [description]
             */
        function trillDeleteBatch() {
            var trillArr = $scope.data.selectedArray,
                hasRightArr = [],
                item = '';
            for (var i = 0; i < trillArr.length; i++) {
                if (trillArr[i].rights[$scope.rightsKey + '.delete']) {
                    hasRightArr.push(trillArr[i]);
                }
            }
            if (hasRightArr.length === 0) {
                modalDialog.alertType('所选' + $scope.mediaName + '账号没有删除权限', '', 'error', false);
            } else if (hasRightArr.length === trillArr.length) {
                item = hasRightArr.map(function(item) {
                    return item[$scope.mediaAccountKey] || item[$scope.accountKey];
                }).join(',');
                modalDialog.alertType('您确定要删除' + hasRightArr.length + '个' + $scope.mediaName + '账号', hasRightArr.map(function(item) {
                    return item.ACCOUNTNAME;
                }).join(','), 'ask', true, function() {
                    deleteTrillAccountMethod(item);
                });
            } else {
                item = hasRightArr.map(function(item) {
                    return item[$scope.mediaAccountKey] || item[$scope.accountKey];
                }).join(',');
                modalDialog.alertType('部分' + $scope.mediaName + '账号没有删除权限，是否删除以下' + $scope.mediaName + '账号', hasRightArr.map(function(item) {
                    return item.ACCOUNTNAME;
                }).join(','), 'ask', true, function() {
                    deleteTrillAccountMethod(item);
                });
            }
        }

        /**
         * [deleteTrillAccountMethod description]删除账号信息
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        function deleteTrillAccountMethod(item) {
            $scope.params = $scope.deleteAccountParams;
            $scope.params[$scope.mediaAccountKey + 'S'] = item;
            $scope.loadingPromise = trsHttpService.httpServer('/wcm/rbcenter.do', $scope.params, 'get').then(function(data) {
                if (angular.isArray(data.REPORTS)) {
                    modalDialog.multiReportsAlert(data, function() {
                        requestData();
                    });
                } else {
                    modalDialog.alertType('', data.DETAIL, 'warning', 'confirm');
                }
            });
        }

        /**
         * [pageChanged description]下一页
         *
         * @return  {[type]}  [return description]
         */
        $scope.pageChanged = function() {
            $scope.searchParams.CurrPage = $scope.page.CURRPAGE;
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };

        /**
         * [jumpToPage description]跳转到某一页
         *
         * @return  {[type]}  [return description]
         */
        $scope.jumpToPage = function() {
            if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
            }
            $scope.searchParams.CurrPage = $scope.status.copyCurrPage;
            $scope.page.CURRPAGE = $scope.status.copyCurrPage;
            requestData();
        };

        /**
         * [requestData description]挂载
         *
         * @return  {[type]}  [return description]
         */
        $scope.requestData = function () {
            requestData();
        };
            
        /**
         * [selectDoc description] 选择/取消选择微博
         * @param  {[Object]} item [description] 微博对象
         * @return {[type]}      [description]
         */
        $scope.selectDoc = function(item) {
            if ($scope.data.selectedArray.indexOf(item) < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            }
        };

        /**
         * [selectAll description] 微博全选/全不选
         * @return {[type]} [description]
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length === $scope.data.items.length ? [] : [].concat($scope.data.items);
        };

        /**
         * [itenInit description] 微博账号index值初始化
         * @param  {[Object]} item   [description] 微博账号
         * @param  {[Number]} $index [description] 微博顺序
         * @return {[type]}        [description]
         */
        $scope.itemInit = function(item, $index) {
            item.index = $index + 1 + ($scope.page.CURRPAGE - 1) * $scope.page.PAGESIZE;
            initBtnRights(item);
        };

        /**
         * [headPicload description] 头像未能正常显示时显示默认头像
         * @param  {[object]} item [description] 微博账号对象
         * @return {[type]}      [description]
         */
        $scope.headPicload = function(item) {
            var imgObj = new Image();
            imgObj.src = item.HEADPIC;
            imgObj.onload = function() {
                item.picUrl = item.HEADPIC;
            };
            imgObj.onerror = function() {
                item.picUrl = './images/user_icon.jpg';
            };
        };
    },
]);
